import $http from '@/libs/axios'

class AnnouncementsAPI {
  static async show(id: number) {
    return (await $http.get(`announcements/show/${id}`)).data?.data
  }

  static async create(payload: any) {
    return (await $http.post('announcements/create', payload)).data
  }

  static async update(payload: any) {
    return (await $http.post('announcements/update', payload)).data
  }

  static async read(id: number, dismissed: boolean) {
    return (await $http.put('announcements/read', { id, dismissed })).data
  }

  static async destroy(id: number) {
    return (await $http.post('announcements/delete', { id, _method: 'delete' })).data
  }
}

export default AnnouncementsAPI
